/*
 * Copyright (c) 2023-2024 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import { z } from 'zod'

export const LabelValue = z.object({
  label: z.string(),
  value: z.string()
})

export interface LabelValue<LabelType = string> {
  label: LabelType
  value: string
}
